(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venora-buybox"] && !Shopify.designMode) return;
  try {
    
  class VenoraProduct extends HTMLElement {
    connectedCallback() {
      this.cartAction = this.dataset.cartAction || 'drawer';
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.variants = this._readJSON('[data-variant-json]');
      this.form = this.querySelector('[data-venora-form]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.qtyInput = this.querySelector('[data-quantity]');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.savingsEl = this.querySelector('[data-savings]');
      this.cta = this.querySelector('[data-cta]');
      this.ctaLabel = this.querySelector('[data-cta-label]');
      this._origCta = this.ctaLabel ? this.ctaLabel.textContent : '';
      this.currentQty = this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1;
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.stickyCta = this.querySelector('[data-sticky-cta]');
      this.stickyCtaLabel = this.querySelector('[data-sticky-cta-label]');
      this.stickyName = this.querySelector('[data-sticky-name]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');

      this._bindBundles();
      this._bindGallery();
      this._bindForm();
      this._bindFaq();
      this._bindCountdown();
      this._bindStickyBar();
      this.querySelectorAll('[data-carousel]').forEach((c) => this._initCarousel(c));
    }

    disconnectedCallback() {
      if (this._timer) clearInterval(this._timer);
      if (this._stickyObserver) this._stickyObserver.disconnect();
    }

    _bindStickyBar() {
      if (!this.stickyBar || !this.form || !('IntersectionObserver' in window)) return;
      if (this.stickyCta) {
        this.stickyCta.addEventListener('click', () => {
          if (this.stickyCta.disabled) return;
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
          else this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        });
      }
      this._stickyObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        // מוצג רק כשהטופס יצא מהמסך כלפי מעלה — לא כשעדיין לא הגענו אליו
        const below = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        this.stickyBar.classList.toggle('is-visible', below);
        this.stickyBar.setAttribute('aria-hidden', below ? 'false' : 'true');
      });
      this._stickyObserver.observe(this.form);
    }

    _syncSticky(label) {
      if (!this.stickyBar) return;
      if (label) {
        const n = label.querySelector('.venora-bundle__name');
        const p = label.querySelector('.venora-bundle__price');
        if (n && this.stickyName) this.stickyName.textContent = n.textContent;
        if (p && this.stickyPrice) this.stickyPrice.textContent = p.textContent;
      }
      if (this.stickyCta && this.cta) {
        this.stickyCta.disabled = this.cta.disabled;
        if (this.stickyCtaLabel && this.ctaLabel) this.stickyCtaLabel.textContent = this.ctaLabel.textContent;
      }
    }

    _bindCountdown() {
      const el = this.querySelector('[data-countdown]');
      if (!el) return;
      const mode = el.dataset.mode || 'midnight';
      const pad = (n) => String(n).padStart(2, '0');
      const nextMidnight = () => { const d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); };
      const key = 'venora_deal_end';
      let resetDur = 0;
      let end;
      if (mode === 'duration') {
        resetDur = (parseFloat(el.dataset.hours) || 24) * 3600 * 1000;
        end = parseInt(localStorage.getItem(key), 10);
        if (!end || isNaN(end) || end < Date.now()) {
          end = Date.now() + resetDur;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
        }
      } else {
        end = nextMidnight();
      }
      const tick = () => {
        let diff = end - Date.now();
        if (diff <= 0) {
          if (mode === 'duration') {
            end = Date.now() + resetDur;
            try { localStorage.setItem(key, String(end)); } catch (e) {}
          } else {
            end = nextMidnight();
          }
          diff = end - Date.now();
        }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      };
      tick();
      this._timer = setInterval(tick, 1000);
    }

    _bindFaq() {
      const items = Array.from(this.querySelectorAll('.venora-faq__item'));
      items.forEach((d) => {
        d.addEventListener('toggle', () => {
          if (d.open) items.forEach((o) => { if (o !== d) o.open = false; });
        });
      });
    }

    _readJSON(sel) {
      const el = this.querySelector(sel);
      if (!el) return [];
      try { return JSON.parse(el.textContent); } catch (e) { return []; }
    }

    _bindBundles() {
      this.querySelectorAll('[data-bundle-option]').forEach((inp) => {
        inp.addEventListener('change', () => this._selectBundle(inp));
      });
    }

    _selectBundle(inp) {
      if (!inp) return;
      const val = inp.value;
      // Visual selected state
      this.querySelectorAll('.venora-bundle').forEach((l) => l.classList.remove('is-selected'));
      const label = inp.closest('.venora-bundle');
      if (label) label.classList.add('is-selected');

      if (val && val.charAt(0) === 'b') {
        // Block-based: quantity-only bundle
        const qty = parseInt(inp.dataset.qty, 10) || 1;
        this.currentQty = qty;
        if (this.qtyInput) this.qtyInput.value = qty;
        this._syncSticky(label);
        return;
      }
      // Variant-based (legacy)
      const v = this.variants.find((x) => String(x.id) === String(val));
      if (!v) return;
      if (this.idInput) this.idInput.value = v.id;
      this.currentQty = 1;
      if (this.qtyInput) this.qtyInput.value = 1;
      if (this.priceEl) this.priceEl.textContent = v.price;
      if (this.compareEl) {
        if (v.compare) { this.compareEl.textContent = v.compare; this.compareEl.hidden = false; }
        else { this.compareEl.hidden = true; }
      }
      if (this.savingsEl) {
        if (v.save_pct > 0) { this.savingsEl.textContent = 'חיסכון ' + v.save_pct + '%'; this.savingsEl.hidden = false; }
        else { this.savingsEl.hidden = true; }
      }
      if (this.cta && this.ctaLabel) {
        this.cta.disabled = !v.available;
        this.ctaLabel.textContent = v.available ? this._origCta : 'אזל מהמלאי';
      }
      this._syncSticky(label);
    }

    _bindGallery() {
      const main = this.querySelector('[data-main-image]');
      const thumbs = this.querySelectorAll('[data-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          const full = t.dataset.full;
          if (full) main.src = full;
          thumbs.forEach((x) => x.classList.remove('is-active'));
          t.classList.add('is-active');
        });
      });
    }

    _bindForm() {
      if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (this.cta && this.cta.disabled) return;

        const items = [];
        const mainId = this.idInput ? parseInt(this.idInput.value, 10) : NaN;
        const mainQty = this.currentQty || (this.qtyInput ? parseInt(this.qtyInput.value, 10) : 1) || 1;
        if (mainId) items.push({ id: mainId, quantity: mainQty });
        this.querySelectorAll('[data-upsell-toggle]').forEach((u) => {
          if (u.checked && u.dataset.variantId) items.push({ id: parseInt(u.dataset.variantId, 10), quantity: 1 });
        });
        if (!items.length) return;

        this._setLoading(true);
        try {
          // Detect cart drawer sections present in the page so we can refresh them
          const sectionsToFetch = [];
          document.querySelectorAll('[id^="shopify-section-"]').forEach((el) => {
            const name = el.id.replace('shopify-section-', '');
            if (/cart|drawer|notification|bubble/i.test(name)) sectionsToFetch.push(name);
          });

          const body = { items };
          if (sectionsToFetch.length) {
            body.sections = sectionsToFetch.join(',');
            body.sections_url = window.location.pathname;
          }

          const res = await fetch(this.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body)
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'אירעה שגיאה בהוספה לעגלה');
          }
          const data = await res.json();
          this._injectSections(data.sections);
          this._onAdded(data);
        } catch (err) {
          this._setLoading(false);
          if (this.ctaLabel) this.ctaLabel.textContent = this._origCta;
          if (this.stickyCtaLabel) this.stickyCtaLabel.textContent = this._origCta;
          window.alert(err.message || 'אירעה שגיאה, נסו שוב');
        }
      });
    }

    _injectSections(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([name, html]) => {
        if (!html) return;
        const target = document.getElementById('shopify-section-' + name);
        if (!target) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const next = parsed.getElementById('shopify-section-' + name);
        if (next) target.innerHTML = next.innerHTML;
      });
    }

    _setLoading(on) {
      if (this.cta) {
        this.cta.classList.toggle('is-loading', on);
        this.cta.disabled = on;
        if (on && this.ctaLabel) this.ctaLabel.textContent = 'מוסיף…';
      }
      if (this.stickyCta) {
        this.stickyCta.classList.toggle('is-loading', on);
        this.stickyCta.disabled = on;
        if (on && this.stickyCtaLabel) this.stickyCtaLabel.textContent = 'מוסיף…';
      }
    }

    _onAdded(addedData) {
      this._setLoading(false);
      this.querySelectorAll('[data-upsell-toggle]').forEach((u) => { u.checked = false; });
      if (this.cta) { this.cta.classList.add('is-success'); this.cta.disabled = false; }
      if (this.ctaLabel) this.ctaLabel.textContent = 'נוסף לעגלה ✓';
      if (this.stickyCta) { this.stickyCta.classList.add('is-success'); this.stickyCta.disabled = false; }
      if (this.stickyCtaLabel) this.stickyCtaLabel.textContent = 'נוסף לעגלה ✓';
      setTimeout(() => {
        if (this.cta) this.cta.classList.remove('is-success');
        if (this.ctaLabel) this.ctaLabel.textContent = this._origCta;
        if (this.stickyCta) this.stickyCta.classList.remove('is-success');
        if (this.stickyCtaLabel) this.stickyCtaLabel.textContent = this._origCta;
      }, 2500);

      // Notify the theme widely — many themes listen on at least one of these
      const detail = { items: (addedData && addedData.items) || [] };
      ['cart:refresh','cart:update','cart:added','cart:items:added','cart-updated','variant:added'].forEach((name) => {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      });
      this._refreshCount();

      if (this.cartAction === 'cart') { window.location.href = this.root + 'cart'; return; }
      if (this.cartAction === 'none') return;
      this._openDrawer();
    }

    async _refreshCount() {
      try {
        const cart = await (await fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        const count = cart.item_count;
        document.querySelectorAll('[data-venora-count], [data-cart-count], .cart-count, .cart-count-bubble, #cart-icon-bubble .cart-count-bubble span').forEach((el) => {
          el.textContent = count;
          el.classList.remove('is-empty');
        });
      } catch (e) { /* no-op */ }
    }

    _openDrawer() {
      // Venora drawer (venora-cart-drawer.liquid) exposes a global opener — prefer it
      if (typeof window.venoraOpenCart === 'function') {
        try { window.venoraOpenCart(); return; } catch (e) {}
      }
      const drawer = document.querySelector('cart-drawer, cart-drawer-component, #cart-drawer, .cart-drawer, [id^="CartDrawer"]');
      // Try clicking the cart icon — most themes' icon toggles the drawer reliably
      const opener = document.querySelector('a[href$="/cart"] [class*="cart"], a[href$="/cart"], [data-cart-toggle], #cart-icon-bubble');
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      let opened = false;
      if (drawer) {
        if (typeof drawer.open === 'function') { try { drawer.open(); opened = true; } catch (e) {} }
        if (!opened && typeof drawer.show === 'function') { try { drawer.show(); opened = true; } catch (e) {} }
        if (!opened) {
          drawer.removeAttribute('hidden');
          drawer.classList.add('active', 'is-open', 'open', 'drawer--open');
          document.body.classList.add('cart-drawer-open');
          // Heuristic: if drawer is still display:none after our toggles, treat as failure
          const cs = getComputedStyle(drawer);
          if (cs.display !== 'none' && cs.visibility !== 'hidden') opened = true;
        }
      }
      if (!opened) {
        // Last resort — safe redirect to the cart page so the user sees the item
        window.location.href = this.root + 'cart';
      }
    }

    _initCarousel(root) {
      const track = root.querySelector('[data-track]');
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const controls = root.querySelector('[data-carousel-controls]');
      if (!track || slides.length <= 1) {
        if (controls) controls.style.display = 'none';
        return;
      }
      let i = 0;
      const dotsWrap = root.querySelector('[data-dots]');
      const dots = [];
      if (dotsWrap) {
        slides.forEach((_, k) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'venora-dot' + (k === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'שקופית ' + (k + 1));
          b.addEventListener('click', () => go(k));
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }
      const update = () => {
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      };
      const go = (k) => { i = (k + slides.length) % slides.length; update(); };
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => go(i - 1));
      if (next) next.addEventListener('click', () => go(i + 1));

      let x0 = null;
      track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx > 0 ? i - 1 : i + 1);
        x0 = null;
      });
      update();
    }
  }

  if (!customElements.get('venora-product')) {
    customElements.define('venora-product', VenoraProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
